module.exports = __webpack_public_path__ + "img/en_tis60_2.84dbc541.png";